import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_ALL_LOB = "GET_ALL_LOB";
export const GET_LOB = "GET_LOB";
export const GET_COST_CENTER_LOB = "GET_COST_CENTER_LOB";
export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const GET_COST_CENTER = "GET_COST_CENTER";
export const CAL_LOADING = "CAL_LOADING";
export const ADD_LOB = "ADD_LOB";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});


export const getAllLobs = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAL_LOADING
    });
    await instance.get(`/AdminLOB/GetAllLOBs/${Token}`).then((res => {
        dispatch({
            type: GET_ALL_LOB,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetLobById = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAL_LOADING
    });
    await instance.get(`/AdminLOB/GetLobById/${id}&${Token}`).then((res => {
        dispatch({
            type: GET_LOB,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetCostCenterByLOBId = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAL_LOADING
    });
    await instance.get(`/AdminLOB/GetCostCenterByLOBId/${id}&${Token}`).then((res => {
        dispatch({
            type: GET_COST_CENTER_LOB,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const addLob = data =>{
  var Token = convertSHA()
  const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
  let formData = new FormData();
  formData.append('CostCenterList', data.cce_id);
     return async dispatch => {
        dispatch({
            type: CAL_LOADING
          });
        console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/AdminLOB/PutInsUpdtLOB/${data.id}&${data.acc_id}&${data.name}&LOB&${data.active}&${data.modified_By}&${Token}`,formData, config  ).then((res => {
            dispatch({
                type: ADD_LOB,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}

export const getAllAccounts = () => {
    var Token = convertSHA()
    return async dispatch => {
      dispatch({
        type: CAL_LOADING
      });
      await instance.get(`/AdminLOB/GetAllAccounts/${Token}`).then((res => {
          dispatch({
              type: GET_ACCOUNTS,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const GetCostCenterByAccount = (acc_id) => {
    var Token = convertSHA()
    return async dispatch => {
      dispatch({
        type: CAL_LOADING
      });
      await instance.get(`/AdminLOB/GetCostCenterByAccount/${acc_id}&${Token}`).then((res => {
          dispatch({
              type: GET_COST_CENTER,
              data: res.data
              })
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const GetLOBByAccount = (acc_id) => {
    var Token = convertSHA()
    return async dispatch => {
      dispatch({
        type: CAL_LOADING
      });
      await instance.get(`/AdminLOB/GetLOBsByAccount/${acc_id}&${Token}`).then((res => {
          dispatch({
              type: GET_LOB,
              data: res.data
              })
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
